module.exports = __webpack_public_path__ + "assets/img/block-right-f9c1f1e3.png";